import { ANY_VALUE_PARTITION_GUID } from '../../Common/Constants/DefaultValues'
import { COMMA } from '../../Common/Constants/Separators'
import { GenericFilterEntityDataItems, GenericFilterEntityItem } from '../../Common/Types/Types'

/**
 * Checks whether the report configuration contains only a single "Any" partition
 * and whether only one partition is available in the entity info partitions.
 *
 * @param rptConfigurationPartitionIds - Comma-separated string of partition IDs from the report configuration. May be null or undefined.
 * @param filterEntityInfoPartitions - The filter entity info containing partition data. May be null or undefined.
 * @returns {boolean} True if the report has only the "Any" partition and only one partition is available in the entity info, otherwise false.
 */
export const checkIfSinglePartitionWhenReportHasAny = (
    rptConfigurationPartitionIds: Nullable<string>,
    filterEntityInfoPartitions: Nullable<GenericFilterEntityItem>
): boolean => {
    const partitionIdsFromReport: string[] = rptConfigurationPartitionIds
        ? rptConfigurationPartitionIds.split(COMMA)
        : []

    const reportHasOnlyAnyPartition: boolean =
        partitionIdsFromReport.length === 1 && partitionIdsFromReport[0].trim() === ANY_VALUE_PARTITION_GUID

    const entityInfoPartitions: GenericFilterEntityDataItems[] = filterEntityInfoPartitions?.Data ?? []
    const hasOnlyOnePartitionAvailable: boolean = entityInfoPartitions.length === 1

    return reportHasOnlyAnyPartition && hasOnlyOnePartitionAvailable
}
